export default "__VITE_ASSET__B98CLA5G__"